<template lang="pug">
#kennel.base-page.grid-box.grid-col
	.cal-container.scroll-y
		KennelCalendar(
			v-model:timeframe="timeframe"
			:kennel="selectedSize"
		)
			template(#header-left)
				.selectors
					.option: select(v-model="selectedSize" :class="selectedSize")
						option(
							v-for="size in Dogspaces.Sizes"
							:key="size"
							:value="size"
						) {{ Dogspaces.SizeTitle[size] }}
			template(#header-right)
				button.primary.icon.bulk-edit(@click="showBulkEdit = true")
					include ../resources/icons/bulk-edit.pug
					| Bulk Edit
	Modal(v-if="showBulkEdit" @close="showBulkEdit = false")
		BulkEdit(:dog-type="selectedSize" @close="showBulkEdit = false")
</template>
<script setup lang="ts">
import { ref } from 'vue';
import KennelCalendar from '@/components/kennel-calendar.vue';
import { Dogspaces } from '@busy-human/k9-library';
import Modal from '@/components/Modal.vue';
import BulkEdit from '@/components/bulk-edit.vue';

const showBulkEdit = ref(false);
const selectedSize = ref(Dogspaces.Sizes.Small);
const timeframe    = ref<{month: number, year: number}>({
	month: new Date().getMonth(),
	year: new Date().getFullYear()
});

// watch(timeframe, async tf => {
// 	await kennelStore.fetchCounts(tf.year, tf.month);
// }, { deep: true, immediate: true });

</script>
<style lang="scss">
#kennel button.bulk-edit{
	svg path{
		fill: white;
	}

	&:hover svg path{
		fill: black;
	}
}
</style>

<!--
<style lang="scss">
/* SCSS moved to management-portal/src/stylesheets/components/calendar.scss */
</style>
-->
